import { Position, Toaster } from "@blueprintjs/core";
 
export const NotificationToaster = Toaster.create({
    className: "notification-toaster",
    position: Position.TOP,
});